// A contact's clinic, and the filter that narrows the contact list by it. The two
// readings of "All" are deliberately different: a contact set to All works at both
// sites, so they belong under either single-site filter, while a filter set to All
// means show everybody. UNASSIGNED is the admin-only filter for contacts that were
// never given a clinic.
export const ALL_CLINICS = 'All'

// "All" on its own is ambiguous next to a job title, so read mode spells it out. The
// stored value stays "All" and the form keeps showing it as-is.
export const ALL_CLINICS_LABEL = 'All Clinics'

export const UNASSIGNED_CLINIC = 'undefined'

export const CLINICS = ['San Francisco', 'Oakland', ALL_CLINICS]

const toOptions = values => values.map(value => ({value, displayValue: value}))

// A contact can be assigned any clinic, and the list filter offers the same choices.
export const clinicOptions = toOptions(CLINICS)

export const filterOptions = clinicOptions

export const adminFilterOptions = [
	...filterOptions,
	{value: UNASSIGNED_CLINIC, displayValue: 'Undefined'}
]

export const matchesClinic = (contact, clinic) => {
	const contactClinic = contact ? contact.clinic : undefined

	if (clinic === ALL_CLINICS) return true
	if (clinic === UNASSIGNED_CLINIC) return !contactClinic

	return contactClinic === clinic || contactClinic === ALL_CLINICS
}

// How a stored clinic is worded in read mode. Every other value is already readable
// as it stands, including one that is not one of the three.
export const clinicLabel = clinic => clinic === ALL_CLINICS ? ALL_CLINICS_LABEL : clinic
